import React from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import RegularButton from "components/CustomButtons/Button";

import { CompaniesStations } from "./CompaniesStations";
import { DateComponent } from "./DateComponent";
import { DatesComponent } from "./DatesComponent";
import { StationsComponent } from "./StationsComponent";
import { UnitsComponent } from "./UnitsComponent";
import { CustomerComponent } from "./CustomerComponent";
import { UsersComponent } from "./UsersComponent";
import { UnitTypeComponent } from "./UnitTypeComponent";

export const TableInputs = ({
  reducer = "search",
  date = false, //una sola fecha
  monthType = false, //fecha solo sea mes y año
  yearType = false, //fecha solo año
  dates = false, //fecha inicial y fecha final
  minDate = null,
  maxDate = null,
  stations = false, //estaciones
  multiStations = false, //multiples estaciones
  limitTags = 3,
  companies = false, //empresas
  enableSelectAll = false, //habilitar seleccionar todo en companies/stations
  units = false,
  unitType = false,
  customers = false,
  users = false,
  dispatchAction = () => ({}), //la accion a ejectutar
  submitButtonName = "Buscar",
  submitAction = null, //el submit definitivo
  submitButtonShow = true,
  submitActionTooltip = "",
  submitSecond = null,
  submitSecondButtonName = "Excel",
  submitSecondTooltip = "",
  submitSecondColor = "info",
  submitSecondDisabled = false,
  submitThird = null,
  submitThirdButtonName = "",
  submitThirdTooltip = "",
  submitThirdColor = "info",
  loading = false,
  children = null,
  stationsGridWidth = 3,
  isWholesaler = false
}) => {
  const state = useSelector((state) => state[reducer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    submitAction(e);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        spacing={2}
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {date && (
          <DateComponent
            state={state}
            date={date}
            dispatchAction={dispatchAction}
            monthType={monthType}
            yearType={yearType}
            limitDates={{
              min: minDate,
              max: maxDate,
            }}
          />
        )}
        {dates && (
          <DatesComponent
            state={state}
            dates={dates}
            limitDates={{
              min: minDate,
              max: maxDate,
            }}
            dispatchAction={dispatchAction}
          />
        )}
        {companies && (
          <CompaniesStations
            state={state}
            companies={companies}
            multiStations={multiStations}
            enableSelectAll={enableSelectAll}
            // Solo el modo select all limita chips; el modo original conserva su comportamiento previo
            limitTags={enableSelectAll ? limitTags : undefined}
            gridWidth={stationsGridWidth}
            dispatchAction={dispatchAction}
          />
        )}
        {(stations || (companies && enableSelectAll)) && (
          <StationsComponent
            state={state}
            stations={stations || enableSelectAll}
            companies={companies}
            multi={multiStations}
            enableSelectAll={enableSelectAll}
            gridWidth={stationsGridWidth}
            limitTags={limitTags}
            dispatchAction={dispatchAction}
          />
        )}
        {units && (
          <UnitsComponent
            state={state}
            isWholesaler={isWholesaler}
            // multi={false}
            dispatchAction={dispatchAction}
          />
        )}
        {unitType && (
          <UnitTypeComponent
            state={state}
            dispatchAction={dispatchAction}
          />
        )}
        {customers && (
          <CustomerComponent
            state={state}
            multi={multiStations}
            customers={customers}
            dispatchAction={dispatchAction}
          />
        )}
        {users && (
          <UsersComponent state={state} dispatchAction={dispatchAction} />
        )}
        {children}
        {submitButtonShow &&
          <Grid item xs={12} sm={1}>
            <RegularButton
              type="submit"
              color="info"
              loading={loading}
              fullWidth
              tooltip={submitActionTooltip}
            >
              {submitButtonName}
            </RegularButton>
          </Grid>
        }
        {submitSecond && (
          <Grid item xs={12} sm={1}>
            <RegularButton
              type="button"
              color={submitSecondColor}
              onClick={submitSecond}
              loading={loading}
              disabled={submitSecondDisabled}
              fullWidth
              tooltip={submitSecondTooltip}
            >
              {submitSecondButtonName}
            </RegularButton>
          </Grid>
        )}
        {submitThird && (
          <Grid item xs={12} sm={1}>
            <RegularButton
              type="button"
              color={submitThirdColor}
              onClick={submitThird}
              loading={loading}
              fullWidth
              tooltip={submitThirdTooltip}
            >
              {submitThirdButtonName}
            </RegularButton>
          </Grid>
        )}
      </Grid>
    </form>
  );
};
